// extracted by css-extract-rspack-plugin
export default {"actions":"Header_actions__jzKVY"};